function resetApi(ajax) {
  function axiosPromise(option) {
    return new Promise((resolve, reject) => {
      function success(res) {
        if (res) {
          resolve(res);
        }
      }
      function error(error) {
        if (error) {
          reject(error);
        }
      }

      const _success = option.success;
      option.success = function (res) {
        if (_success) {
          _success(res);
        }
        success(res);
      };
      const _error = option.error;
      option.error = function (err) {
        if (_error) {
          _error(err);
        }
        error(err);
      };

      ajax(option);
    });
  }

  return axiosPromise;
}

export default resetApi;
